module.exports = __webpack_public_path__ + "img/dark-logo.c784687f.png";